// @flow
import {
    CHANGE_ZONE,
    LOAD_NOTIFICATIONS,
    RECEIVED_NOTIFICATIONS,
    SAVE_NOTIFICATIONS,
    SAVE_NOTIFICATIONS_ERROR,
    SAVED_NOTIFICATIONS
} from './constants';

import { createAction } from 'redux-actions';

export const changeZone = createAction(CHANGE_ZONE);
export const loadNotifications = createAction(LOAD_NOTIFICATIONS);
export const receivedNotifications = createAction(RECEIVED_NOTIFICATIONS);
export const saveNotifications = createAction(SAVE_NOTIFICATIONS);
export const saveNotificationsError = createAction(SAVE_NOTIFICATIONS_ERROR);
export const savedNotifications = createAction(SAVED_NOTIFICATIONS);



// WEBPACK FOOTER //
// ./src/core/state/notifications/actions.js